import { jsx } from 'react/jsx-runtime';
import { StatsigProvider } from '@statsig/react-bindings';

const defaultUser = {
    userID: 'default_user'
};
const HermesStatsigProvider = ({ children, user = defaultUser, sdkKey }) => {
    if (!sdkKey) {
        throw new Error('Statsig SDK key is missing!');
    }
    return (jsx(StatsigProvider, { sdkKey: sdkKey, user: user, children: children }));
};

export { HermesStatsigProvider };
